import React, { useState, useEffect } from "react";

import Layout from "../../Layout/Layout";

import DataTable from "./Table";

const Banners = () => {
  return (
    <Layout>
      <DataTable />
    </Layout>
  );
};

export default Banners;
